import { render, staticRenderFns } from "./CadastroFeriados.vue?vue&type=template&id=4d014630&"
import script from "./CadastroFeriados.vue?vue&type=script&lang=js&"
export * from "./CadastroFeriados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports